module.exports = __webpack_public_path__ + "img/index07.d7f48fce.jpg";